<template>
  <div class="edit_frame">
    <div class="title">
        二维码区块
    </div>
    <section class=" text-content" v-if="page.bodyConfig">
        <div class="subtitle">二维码布局</div>
        <el-radio-group
            direction="horizontal"
            v-model="page.bodyConfig.qyCodeLayout"
            @change="layoutChange">
            <el-radio label="left"> 居左 </el-radio>
            <el-radio label="right" > 居右 </el-radio>
        </el-radio-group>
        <div class="subtitle">二维码位置</div>
        <el-radio-group
            direction="horizontal"
            @change="locationChange"
            v-model="page.bodyConfig.qyCodelocation">
            <el-radio label="top" > 海报上方 </el-radio>
            <el-radio label="bottom" > 海报下方 </el-radio>
        </el-radio-group>
        <div class="subtitle">分享文案标题</div>
        <el-input type="text" placeholder="请输入" size="medium"  v-model="shareTitle" @change="titleChange" maxlength="10" show-word-limit> </el-input>
        <div class="subtitle">分享文案正文</div>
        <el-input type="text" placeholder="请输入" size="medium" v-model="shareText" @change="textChange" maxlength="10" show-word-limit> </el-input>
    </section>
    <template >
        <!-- 选中挂件是职位信息才展示该配置 -->
        <div class="title">
            职位信息
        </div>
        <div class="position mt-20">
            <el-checkbox-group
                v-model="selectPositionInfoList"
                direction="horizontal"
                @change="handlePositionInfoChange"
            >
                <el-checkbox v-for="item in positionList" :key="item.label" :label="item.label" >{{item.label}}</el-checkbox>
            </el-checkbox-group>
        </div>
    </template>
  
  </div>
</template>

<script type="text/javascript">
import { richTextHelper } from '@/base/richTextHelper'

export default {
  name: 'BasicTextEdit',
  components: {
  },
  data() {
    return {
      font_family: '',
      font_size: 14,
      color: '',
      module: null,
      checkList: [],
      textList: {
        '招聘类别': '<img src="/img/poster/icon1.png"/>默认类别&nbsp; &nbsp; &nbsp;',
        '工作性质': '<img src="/img/poster/icon2.png"/>全职&nbsp; &nbsp; &nbsp;',
        '工作地点': '<img src="/img/poster/icon3.png"/>全国'
      },
      shareTitle: '长按识别二维码',
      shareText: '查看职位详情',
      selectPositionInfoList: []
    }
  },
  props: {
    // 是否处于多选状态
    multiple: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    // 当前选中的页面数据
    page() {
      const pages = this.$store.state.body.data.pages
      return pages
    },
    positionList() {
      return this.$store.state.options.positionInfo
    },
    select_module() {
      return this.$store.state.widgets.select_module
    },
    widgets() {
      return this.templet.get_widgets()
    },
  },
  methods: {
    locationChange(val){
        this.widgets.map(widgets => {
            if(val == 'bottom') {
                if(widgets.blockType == 'qrCodeBlock') {
                    widgets.style.top = Number(widgets.style.top) + 414
                } else if(widgets.name != '中间区块' && widgets.name !='中间背景色块'){
                    widgets.style.top = Number(widgets.style.top) - 90
                }
            } else {
                if(widgets.blockType == 'qrCodeBlock') {
                    widgets.style.top = Number(widgets.style.top) - 414
                } else if(widgets.name != '中间区块' && widgets.name !='中间背景色块'){
                    widgets.style.top = Number(widgets.style.top) + 90
                }
                
            }
        })
    },
    layoutChange(val){
        this.widgets.map(widgets => {
            if(val == 'left') {
                if (widgets.textType === 'shareTitle') widgets.style.left = '112'
                if (widgets.textType === 'shareText') widgets.style.left = '112'
                if (widgets.imgType === 'qrCode') widgets.style.left = '28'
            } else if(val == 'right') {
                if (widgets.textType === 'shareTitle') widgets.style.left = '28'
                if (widgets.textType === 'shareText') widgets.style.left = '28'
                if (widgets.imgType === 'qrCode') widgets.style.left = '280'
            }
           
        })
    },
    titleChange(val){
        this.widgets.map(widgets => {
            if (widgets.textType === 'shareTitle') {
                if (val) {
                    widgets.text = `<span style="font-size: 20px;">${val}</span>`
                    widgets.style.height = 'auto'
                } else {
                    widgets.text = ''
                    widgets.style.height = 0
                }
            }
        })
    },
    textChange(val){
        this.widgets.map(widgets => {
            if (widgets.textType === 'shareText') {
                if (val) {
                    widgets.text = val
                    widgets.style.height = 'auto'
                } else {
                    widgets.text = ''
                    widgets.style.height = 0
                }
            }
        })
    },
    handlePositionInfoChange(val) {
      var getSelectData = this.positionList.filter(item => { return val.includes(item.label) })
      var selectText = ''
      var content = ''
      //  选择职位属性排序
      getSelectData.sort(function (a, b) {
        return a.sort - b.sort
      })
      var selectLabel = getSelectData.map(item => item.label)
      this.selectPositionInfoList = JSON.parse(JSON.stringify(selectLabel))
      selectLabel.forEach(text => {
        if (this.textList[text]) content = content + this.textList[text]
      })
      this.widgets.map(widgets => {
        if (widgets.textType === 'infoIcon') {
          if (content) {
            widgets.text = `<span style="font-size: 16px;">${content}</span>`
            widgets.style.height = 'auto'
            console.log(widgets.text,'widgets.text')
          } else {
            widgets.text = ''
            widgets.style.height = 0
          }
        }
        if (widgets.textType === 'positionInfo') {
            widgets.positionInfoList = this.selectPositionInfoList
            if(getSelectData.length) {
                selectText = getSelectData.map(item => item.text)
                widgets.text = selectText.join(' | ')
            }
            
        }
      })
    },
    /**
     * 判断变量是否一致
     * @param {*} variable 变量名
     * @param {*} value 如果不一致，需要设置的值
     * @param {*} type 类型 style/shadow
     */
    isSame(variable, value, type = 'style') {
      const temp = this.select_module[0][type][variable]
      const isSameTemp = !this.select_module.some(item => {
        return item[type][variable] !== temp
      })
      if (!isSameTemp && variable === 'font-size') {
        const arr = []
        this.select_module.forEach(item => {
          arr.push(item[type][variable])
        })
        // 取字号最大值
        value = Math.max(...arr)
      }
      this.$set(this.module[type], variable, isSameTemp ? temp : value)
    },
    // 返回watcher
    getWatcher(variable, type = 'style') {
      // watch只支持简单点运算，所以需要函数方式
      return this.$watch(
        () => {
          return this.module[type][variable]
        },
        val => {
          this.select_module.forEach(item => {
            item[type][variable] = val
          })
        }
      )
    },
    getAllIndexes(str, charToFind, startIndex = 0) {
        const indexes = [];
        let foundIndex;
        
        while ((foundIndex = str.indexOf(charToFind, startIndex)) !== -1) {
            indexes.push(foundIndex);
            startIndex = foundIndex + 1;
        }
        
        return indexes
    }
  },
  mounted(){
  },
  created() {
    const _module = this.$store.state.widgets.module_Data
    if(this.widgets.length) {
        var findSelectPosition = this.widgets.find(widgets=> widgets.textType == 'positionInfo')
        this.selectPositionInfoList =  findSelectPosition.positionInfoList
    }
    if (!this.multiple) {
      this.module = _module
      this.color = this.module.style.color
    } else {
      this.module = { style: {}, shadow: {}}
      this.isSame('font-family', '')
      this.isSame('font-size', null)
      this.isSame('text-align', '')
      this.isSame('line-height', 24)
      this.getWatcher('line-height')
      this.isSame('letter-spacing', 0)
      this.getWatcher('letter-spacing')
      this.isSame('color', '#000000')
      this.isSame('background', '#FFFFFF')
      this.getWatcher('background')
      this.isSame('x', null, 'shadow')
      this.getWatcher('x', 'shadow')
      this.isSame('y', null, 'shadow')
      this.getWatcher('y', 'shadow')
      this.isSame('blur', null, 'shadow')
      this.getWatcher('blur', 'shadow')
      this.isSame('color', '#7D7D7D', 'shadow')
      this.getWatcher('color', 'shadow')
      this.isSame('opacity', 1)
      this.getWatcher('opacity')
      this.isSame('rotate', 0)
      this.getWatcher('rotate')
    }
  },
  mounted() {
    var hasPositionNumber = 0
    // 挂件循环，没有职位信息清空职位信息的选项
    this.widgets.forEach(item=> {
      if(item.textType === 'positionInfo') {
        hasPositionNumber++
      }
      if(item.textType === 'shareTitle') {
        var starIndexs = this.getAllIndexes(item.text, '>')
        var endIndexs = this.getAllIndexes(item.text, '<')
        this.shareTitle = item.text.substring(starIndexs[0]+1, endIndexs[1])
      }
      if(item.textType === 'shareText') {
        var starIndexs = this.getAllIndexes(item.text, '>')
        var endIndexs = this.getAllIndexes(item.text, '<')
        this.shareText = item.text.substring(starIndexs[0]+1, endIndexs[1])
      }
    })
    if(!hasPositionNumber && this.$route.query.type!='operatingActivities') {
      this.module.textType = ''
      this.module.positionInfoList = []
    }
  }
}
</script>

<style lang="scss" scoped>
.title{
    font-size: 14px;
    color: #1D2129;
    font-weight: 500;
    line-height: 40px;
    border-bottom:#F2F3F5 solid 1px;
}
.subtitle{
    font-size: 14px;
    color: #4E5969;
    margin-top: 20px;
    margin-bottom: 4px;
}
.position{
    .el-checkbox-group{
        flex-wrap: wrap;
        justify-content: space-between;
        .el-checkbox{
            margin-bottom: 14px;
            width: 50%;
            margin-right: 0;
        }
    }
}
.text-content{
    position: relative;
    .my_color_layer{
        position: absolute;
        left:1px;
        bottom: 1px;
        opacity: 0;
        width: 66px;
        overflow: hidden;
        height: 32px;
    }
}
.flexbox {
    display: flex;
    justify-content: space-between;
    .edit_item_font_size_new{
        width: 90px;
        flex: none!important;
    }
}
.img-bottom {
  margin-left: 0px !important;
}
.line {
  margin-right: 16px;
  margin-bottom: 10px;
  border-bottom: 1px solid #f5f5f5;
}
.edit_frame {
  padding-top: 8px;
  .flexbox {
    align-items: center;
  }
  ::v-deep {
    .shadowItem {
      margin-bottom: 12px;
      .color_box {
        margin-right: 7px;
      }
    }
    .sel_family {
      margin-bottom: 12px;
      .el-select {
        width: 100% !important;
      }
      .el-input__inner {
        font-size: 12px;
        color: #333333;
      }
      .el-input__icon {
        line-height: 24px;
        font-size: 12px;
      }
    }
    .sel_style {
      margin-top: 12px;
      border-radius: 4px;
    }
    .sel_align {
      margin-top: 12px;
      margin-bottom: 12px !important;
      border-radius: 4px;
    }
    .sel_bg {
      .my_edit_item {
        margin-bottom: 12px;
      }
      .color_box {
        width: 60px;
      }
    }
    .sel_powerover {
      position: relative;
      .my_edit_item {
        margin-bottom: 0px;
      }
      .color_box {
        img {
          width: 24px;
          height: 24px;
        }
      }
      .my_color_layer {
        .normal-color-wrapper {
          .title {
            margin-top: 2px;
          }
        }
      }
      > div {
        flex: 1;
      }
    }
    .sel_fshadow {
      margin-bottom: 12px;
    }
  }

  .sel_box {
    position: absolute;
    width: 100%;
    top: 28px;
    left: 0px;
    z-index: 1;
  }

  .right-color {
    flex: 1;
    padding-left: 10px;
  }
  .hideItem {
    margin-bottom: 8px;
  }
  .bottom {
    margin-bottom: 30px;
  }

  .bottom_small {
    margin-bottom: 10px;
  }

  ::v-deep .my_edit_item.color_item {
    display: inline-block;
    width: 50%;
  }
}

.section-title {
  // height: 0;
  // position: relative;
  // border-bottom: 1px solid #ddd;
  margin-bottom: 10px;
  margin-top: 10px;

  .section-title-text {
    // position: absolute;
    background: #fff;
    // left: 0;
    padding-right: 10px;
    font-size: 14px;
    line-height: 1;
    // top: -7px;
  }
}

.item-title {
  font-size: 14px;
  margin-bottom: 10px;
}

.my_edit_item {
  flex: 1;
}

::v-deep {
  .el-input-number--medium {
    .el-icon-arrow-down:before {
      content: '\e790';
    }

    .el-icon-arrow-up:before {
      content: '\e78f';
    }

    .el-input__inner {
      padding-top: 4px;
    }

    .el-input-number__decrease,
    .el-input-number__increase {
      color: #5f6c87;
      background-color: transparent;
      border-left: none !important;
      border-bottom: none !important;
    }

    .el-input-number__decrease {
      bottom: 5px !important;
    }

    .el-input-number__increase {
      top: 8px !important;
    }
  }
  .el-input--small .el-input__inner,
  .my-num-symbol {
    height: 24px !important;
    line-height: 24px !important;
  }
  .el-input-number--small {
    line-height: 24px;
  }
}
</style>
<style>
[readonly='readonly'] {
  user-select: none;
}
</style>
